import { render, staticRenderFns } from "./sjdcrz.vue?vue&type=template&id=28730889&scoped=true&"
import script from "./sjdcrz.vue?vue&type=script&lang=js&"
export * from "./sjdcrz.vue?vue&type=script&lang=js&"
import style0 from "./sjdcrz.vue?vue&type=style&index=0&id=28730889&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28730889",
  null
  
)

export default component.exports